export default [
  'en',
  'de',
  'ru',
];
